//start rating component
import React from 'react'
import Rating from 'react-rating'
import config from '../config'
const cdnpath = config.cdnpath

class StarRatingHOC extends React.Component {

  ratingErrorClass = () => {
    if(this.props.ratingError){
      return 'error'
    }else{
      return ''
    }
  }


  render () {
    return (
      <Rating 
      empty={<img alt="off" src={`${cdnpath}/images/starOff.png`} />}
      full={<img alt="on" src={`${cdnpath}/images/starOn.png`} />}
      className={`StarRatingComponent ${this.ratingErrorClass()}`}
      initialRate={ this.props.rate }
      onClick={ this.handleRatingClick }
      onChange={ this.props.onRatingUpdate }
    />
    )
  }

  handleRatingClick = function(rate, event) {
    event.stopPropagation()
  }

}



export default StarRatingHOC



// WEBPACK FOOTER //
// ./src/components/StarRatingHOC.js